import moment from "moment";

const initialState = {
  schForm: {
    schStrtYmd: moment()
      .subtract("30", "days")
      .format("YYYYMMDD"),
    schEndYmd: moment().format("YYYYMMDD"),
  },
  pointData: "",
  loading: true,
};

export const LOADING = "LOADING";
export const loadingAction = (data) => ({
  type: LOADING,
  payload: data,
});

export const SET_FORM = "SET_FORM";
export const schFormAction = (data) => ({
  type: SET_FORM,
  payload: data,
});

export const LOAD_POINT = "LOAD_POINT";
export const loadPointAction = (data) => ({
  type: LOAD_POINT,
  payload: data,
});

export const LOAD_POINT_SUCCESS = "LOAD_POINT_SUCCESS";
export const loadPointSuccessAction = (list) => ({
  type: LOAD_POINT_SUCCESS,
  payload: list,
});

export default function PointReducer(state = initialState, action) {
  const { type, payload, error } = action;

  console.log("pointReducer = type", type, "payload", payload);

  switch (type) {
    case LOADING:
      return {
        ...state,
        loading: payload,
      };
    case SET_FORM:
      return {
        ...state,
        schForm: payload,
      };
    case LOAD_POINT:
      return {
        ...state,
        schForm: payload,
      };
    case LOAD_POINT_SUCCESS:
      return {
        ...state,
        pointData: payload,
        loading: false,
      };
    default:
      return state;
  }
}
